import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import SUKLCredentialsSetupForm from './SUKLCredentialsSetupForm';
import { Size } from '../../../../Enums/Size.enum';

const SUKLCredentialsSetupFormModal: React.FC<BaseModalProps> = props => (
	<BaseModal
		title='component.userSuklLoginCredentials.title'
		size={Size.LG}
		{...props}>
		<SUKLCredentialsSetupForm onSuccess={props.onClose} />
	</BaseModal>
);

export default SUKLCredentialsSetupFormModal;
